import axios from 'axios';
import { env } from '../env';

export const Api = axios.create({
  baseURL: env.API_BACKEND
});

export const API_URL = env.API_BACKEND;
